import "../../styles/atoms.scss";
import "../../styles/compo.scss";
import CheckBtn from "../../ui/atoms/CheckBtnZ";
import Inputz from "../../ui/atoms/Inputz";
import { useEffect, useState } from "react";

const SocialMedia = ({
  data,
  handleChange,
  visibleInputs,
  setVisibleInputs,
  errors,
  setData,
  socialOrder: socialOrderProp,
  setSocialOrder: setSocialOrderProp,
}) => {
  const [maxInputsReached, setMaxInputsReached] = useState(false);
  const [internalOrder, setInternalOrder] = useState([]);
  const isOrderControlled = typeof setSocialOrderProp === "function";
  const activeOrder = isOrderControlled ? socialOrderProp || [] : internalOrder;
  const setActiveOrder = isOrderControlled ? setSocialOrderProp : setInternalOrder;

  const toggleInput = (platform) => {
    setVisibleInputs((prev) => {
      let value = "";

      if (!prev[platform]) {
        const visibleCount = Object.values(prev).filter(Boolean).length;
        if (visibleCount >= 5) {
          return prev;
        }
        setData({ ...data, [platform]: prev[platform]?.value });
        setActiveOrder((order) => [
          platform,
          ...order.filter((p) => p !== platform),
        ]);
      } else if (prev[platform]) {
        setData((prev) => {
          delete prev[platform];
          return { ...prev };
        });
        setActiveOrder((order) => order.filter((p) => p !== platform));
      }
      return {
        ...prev,
        [platform]: !prev[platform],
      };
    });
  };

  useEffect(() => {
    setMaxInputsReached(
      Object.values(visibleInputs).filter(Boolean).length >= 5
    );
  }, [visibleInputs]);

  useEffect(() => {
    if (isOrderControlled) return;
    const enabled = Object.entries(visibleInputs || {})
      .filter(([, on]) => Boolean(on))
      .map(([key]) => key);
    setActiveOrder((prev) => {
      let next = prev.filter((p) => enabled.includes(p));
      enabled.forEach((p) => {
        if (!next.includes(p)) next = [p, ...next];
      });
      return next;
    });
  }, [visibleInputs, isOrderControlled, setActiveOrder]);

  const renderInput = (platform) => {
    switch (platform) {
      case "figma":
        return (
          <Inputz
            iconL="figma_line"
            focusL="figma_line"
            type="url"
            name="figma"
            placeholder="Figma URL"
            value={data.figma || ""}
            onChange={handleChange}
            error={errors?.figma}
          />
        );
      case "dribbble":
        return (
          <Inputz
            iconL="dribbble_line"
            focusL="dribbble_line"
            type="url"
            name="dribbble"
            placeholder="Dribbble URL"
            value={data.dribbble || ""}
            onChange={handleChange}
            error={errors?.dribbble}
          />
        );
      case "behance":
        return (
          <Inputz
            iconL="behance_line"
            focusL="behance_line"
            type="url"
            name="behance"
            placeholder="Behance URL"
            value={data.behance || ""}
            onChange={handleChange}
            error={errors?.behance}
          />
        );
      case "linkedin":
        return (
          <Inputz
            iconL="linkedin_line"
            focusL="linkedin_line"
            type="url"
            name="linkedin"
            placeholder="LinkedIn URL"
            value={data.linkedin || ""}
            onChange={handleChange}
            error={errors?.linkedin}
          />
        );
      case "x":
        return (
          <Inputz
            iconL="twitter_line"
            focusL="twitter_line"
            type="url"
            name="x"
            placeholder="X URL"
            value={data.x || ""}
            onChange={handleChange}
            error={errors?.x}
          />
        );
      case "instagram":
        return (
          <Inputz
            iconL="instagram_line"
            focusL="instagram_line"
            type="url"
            name="instagram"
            placeholder="Instagram URL"
            value={data.instagram || ""}
            onChange={handleChange}
            error={errors?.instagram}
          />
        );
      case "facebook":
        return (
          <Inputz
            iconL="facebook_line"
            focusL="facebook_line"
            type="url"
            name="facebook"
            placeholder="Facebook URL"
            value={data.facebook || ""}
            onChange={handleChange}
            error={errors?.facebook}
          />
        );
      case "tiktok":
        return (
          <Inputz
            iconL="tiktok_line"
            focusL="tiktok_line"
            type="url"
            name="tiktok"
            placeholder="TikTok URL"
            value={data.tiktok || ""}
            onChange={handleChange}
            error={errors?.tiktok}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="social-box">
      <div className="text-hint-box">
        Add your personal social media links (max 5 links)
      </div>
      <div className="social-icon">
        <CheckBtn
          iconOn="figma_line"
          iconOff="figma_line"
          onChange={() => toggleInput("figma")}
          disabled={maxInputsReached}
          checked={visibleInputs.figma}
        />
        <CheckBtn
          iconOn="dribbble_line"
          iconOff="dribbble_line"
          onChange={() => toggleInput("dribbble")}
          disabled={maxInputsReached && !visibleInputs.dribbble}
          checked={visibleInputs.dribbble}
        />
        <CheckBtn
          iconOn="behance_line"
          iconOff="behance_line"
          onChange={() => toggleInput("behance")}
          disabled={maxInputsReached && !visibleInputs.behance}
          checked={visibleInputs.behance}
        />
        <CheckBtn
          iconOn="linkedin_line"
          iconOff="linkedin_line"
          onChange={() => toggleInput("linkedin")}
          disabled={maxInputsReached && !visibleInputs.linkedin}
          checked={visibleInputs.linkedin}
        />
        <CheckBtn
          iconOn="twitter_line"
          iconOff="twitter_line"
          onChange={() => toggleInput("x")}
          disabled={maxInputsReached && !visibleInputs.x}
          checked={visibleInputs.x}
        />
        <CheckBtn
          iconOn="instagram_line"
          iconOff="instagram_line"
          onChange={() => toggleInput("instagram")}
          disabled={maxInputsReached && !visibleInputs.instagram}
          checked={visibleInputs.instagram}
        />
        <CheckBtn
          iconOn="facebook_line"
          iconOff="facebook_line"
          onChange={() => toggleInput("facebook")}
          disabled={maxInputsReached && !visibleInputs.facebook}
          checked={visibleInputs.facebook}
        />
        <CheckBtn
          iconOn="tiktok_line"
          iconOff="tiktok_line"
          onChange={() => toggleInput("tiktok")}
          disabled={maxInputsReached && !visibleInputs.tiktok}
          checked={visibleInputs.tiktok}
        />
      </div>
      <div className="form-box">
        {activeOrder.map((platform) => (
          <div key={platform}>{renderInput(platform)}</div>
        ))}
      </div>
    </div>
  );
};

export default SocialMedia;
